/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
    factory('Order_Resource',["$resource","$location", function ($resource,$location)
    {
        var resourceBooking;
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        resourceBooking = $resource(baseUrl + 'rest/orders/:date/:id', {}, {
            query: { method: 'GET', isArray: true },
            get: { method: 'GET' }
        });
        return resourceBooking;
    }
    ]);

angular.module('FlexyBeautyApp.services').
factory('Order', ["OrderData","OrderProduct","Order_Resource","HumanResourceData",
        function (OrderData,OrderProduct,Order_Resource,HumanResourceData)
    {

    var  Order = function (orderRes,mustloadElements,isPreviousVersion)
    {
        this.id = null;
        this.isDeleted = false;
        this.timeCreated = null;
        this.price =0;
        this.description = null;
        this.stockDate = null;
        this.billNumber = null;
        this.status="created";//created
        this.humanResource =null;
        this.orderProducts=[];
        this.version = null;
        if (orderRes!==undefined && orderRes!=null)
        {
            this.loadObjectProperties(orderRes);
            if (mustloadElements) {
                this.loadObjectOrderProducts(orderRes);
            }
        }
        if (isPreviousVersion==undefined || !isPreviousVersion)//A previous version is not added to DATA
            OrderData.add(this);
    };
    Order.prototype.loadObjectProperties = function(object)
    {
        if (object)
        {
            if (!this.id)
                this.id =  object.id;
            this.orderNumber = object.orderNumber;
            if (object.timeCreated)
                this.timeCreated = new Date(object.timeCreated);
            this.status = object.status;
            this.price = object.price;
            this.description = object.description;
            this.billNumber = object.billNumber;
            if (object.stockDate)
                this.stockDate = new Date(object.stockDate);
            if (object.humanResourceId)
                this.humanResource = HumanResourceData.getById(object.humanResourceId);
            if (object.version)
                this.version = object.version;
        }
    };

    Order.prototype.loadObjectOrderProducts = function(object)
    {
        if (object.orderProducts)
        {
            this.orderProducts=[];//set to 0 and reload
            for (var i=0;i< object.orderProducts.length;i++)
                this.addOrderProduct(new OrderProduct(object.orderProducts[i]));
        }
    };
    Order.prototype.loadObject = function(object)
    {
        this.loadObjectProperties(object);
        this.loadObjectOrderProducts(object);
    };
    Order.prototype.loadRef = function(isPreviousVersion)
    {
        if (this.orderProducts)
            for (var i=0; i< this.orderProducts.length;i++)
                this.orderProducts[i].loadRef();
    };

    Order.prototype.getObjectResource = function()
    {
        var orderRes = new Order_Resource();
        //customer = booking.customer when booking is saved.
        orderRes.id = this.id;
        orderRes.orderNumber = this.orderNumber;
        orderRes.price = this.price;
        orderRes.description = this.description;
        orderRes.status = this.status;
        orderRes.billNumber = this.billNumber;
        orderRes.stockDate = this.stockDate;
        if (this.humanResource)
            orderRes.humanResourceId = this.humanResource.id;
        orderRes.orderProducts=[];
        for (var i=0;i< this.orderProducts.length;i++){
            orderRes.orderProducts.push(this.orderProducts[i].getObjectResource());
        }

        return orderRes;
    };
    Order.prototype.getOrderProductById = function(id)
    {
        for (var i=0; i< this.orderProducts.length;i++)
            if (this.orderProducts[i].id==id)
                return this.orderProducts[i];
        return null;
    };
    Order.prototype.addOrderProduct = function(orderProduct)
    {
        var index =  this.orderProducts.indexOf(orderProduct);
        if (index==-1)
        {
            this.orderProducts.push(orderProduct);
            orderProduct.order = this;
        }
    };
    Order.prototype.removeOrderProduct = function(orderProduct)
    {
        if (orderProduct!=null)
        {
            var index =  this.orderProducts.indexOf(orderProduct);
            if (index!=-1)
                this.orderProducts.splice(index,1);
            orderProduct.order = null;
        }

    };
    return Order;
}]);
angular.module('FlexyBeautyApp.services').
    factory('OrderSrv',["$rootScope","$log","ServerSrv","Order_Resource","Order","UserActionData","OrderData",
        function ($rootScope,$log,ServerSrv,Order_Resource,Order,UserActionData,OrderData)
        {
            var  orderSrv = {};
            orderSrv.loadRef=  function()
            {
                var orders = OrderData.indexOrders;
                for (var i=0;i<orders.length;i++)
                    orders[i].loadRef();
            };
            orderSrv.query = function(successFunction,errorFunction)
            {
                Order_Resource.query(
                    {}, //params
                    function (data) {   //success
                        OrderData.clear() ;
                        for (var i=0;i< data.length;i++)
                            new Order(data[i],true,false);//Auto Add to OrderData
                        if (successFunction!== undefined)
                            successFunction(OrderData.getActiveList());

                    },
                    function (data) {   //failure
                        $log.error("Order_Resource.query error");
                        $log.error(data);
                        if (errorFunction!== undefined)
                            errorFunction(data);
                    });
            };
            orderSrv.save =  function(order,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(orderSrv.saveSync, order, successFunction, errorFunction);
            };
            orderSrv.saveSync =  function(order,successFunction,errorFunction)
            {
                //$timeout (function () {

                var orderRes = order.getObjectResource();
                orderRes.$save({}, //no params
                    function (orderRes) {
                        /** @namespace orderRes.ordersId */
                        /** @namespace orderRes.orderServicesId */
                        /** @namespace orderRes.orderProductsId */

                        try {
                            order.id = orderRes.id;
                            if (!order.version || (orderRes.version && orderRes.version > order.version))
                                order.version = orderRes.version;
                            if (orderRes.timeCreated)
                                order.timeCreated = new Date(orderRes.timeCreated);

                            if (orderRes.orderNumber)
                                order.orderNumber = orderRes.orderNumber;

                            for (var j=0;j< orderRes.orderProducts.length;j++)
                                order.orderProducts[j].setId(orderRes.orderProducts[j].id);

                            //Add user action
                            UserActionData.add(orderRes.userAction);
                            //CallBack on success
                            if (successFunction !=undefined)
                                successFunction(orderRes);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try {
                            var errorMessage = "Erreur inconnue lors de la sauvegarde."
                            if (data.status && data.data )
                            {
                                if (data.status=="409" )
                                {
                                    if (data.data.errorCode == "40900")
                                        errorMessage = "L'heure choisie pour la réservation n'est plus disponible.";
                                }
                            }
                            if (errorFunction !=undefined)
                                errorFunction(errorMessage);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };
            orderSrv.remove =  function(order,successFunction,errorFunction)
            {
                //Remove directly from model
                ServerSrv.startSavingProcess(orderSrv.removeSync, order, successFunction, errorFunction);
            };
            orderSrv.removeSync =  function(order,successFunction,errorFunction)
            {
                //$timeout (function () {

                var orderSrv = new Order_Resource();
                orderSrv.$remove({id:order.id}, //params : id
                    function (data) {
                        try {
                            UserActionData.add(data.userAction);
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try {
                            if (errorFunction !=undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };
            orderSrv.removeLocally = function(id,resource)
            {
                var order =  OrderData.getById(id);
                if (order && order.version && resource.version && resource.version < order.version)
                    return null;

                return order;
            };
            orderSrv.addLocally =  function(id,resource)
            {
                var order =  OrderData.getById(id)
                if (order && order.version && resource.version && resource.version < order.version)
                    return null;

                if (order!=null) //check if resource already exist inside index (current action could be a 'cancel')
                {
                    order.loadObjectProperties(resource);
                }
                else
                {
                    order = new Order(resource,false,false);//dont load orderProduct (will be done after)
                    order.id = id;
                }
                order.loadRef();

                return order;
            };
            orderSrv.updateLocally =  function(id,resource)
            {

                var order =  OrderData.getById(id);
                if (order && order.version && resource.version && resource.version < order.version)
                    return null;

                if (order)
                {
                    order.loadObject(resource);
                    order.loadRef();//Will add to order
                }
                return order;
            };
            orderSrv.getPreviousVersionInstance =  function(resource)
            {
                var order =  new Order(resource,false,true);
                return order;
            };

            return orderSrv;
        }
    ]);
angular.module('FlexyBeautyApp.services').
    factory('OrderData',["$log", function ($log)
    {
        var  orderData =
        {
            indexOrders : []
        };
        orderData.getById =  function(orderId)
        {
            for (var i=0;i<this.indexOrders.length;i++)
                if (this.indexOrders[i].id==orderId)
                    return this.indexOrders[i];
            return null;
        }
        orderData.getIndexOf =  function(order)
        {
            if (order)
                return this.indexOrders.indexOf(order);
            return -1;
        }
        orderData.getByIndex =  function(index)
        {
            if (index>=0 && index<this.indexOrders.length)
                return this.indexOrders[index];
            else
                return null;
        }
        orderData.getActiveList =  function()
        {
            return this.indexOrders;
        }

        orderData.add =  function(order)
        {
            //to do add always sorted
            this.indexOrders.push(order);

        }
        orderData.clear =  function()
        {
            orderData.indexOrders = [];
        }
        return orderData;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/models/Order.js